import React from 'react';
import Layout from '../components/theme/layout';
import Seo from '../components/theme/seo';

import { useStrapiContext } from '../components/context/StrapiContext';
import {
  FaMapMarkerAlt,
  FaPhoneAlt,
  FaClock,
  FaEnvelope,
} from 'react-icons/fa';

function formatPhoneNumber(phoneNumber) {
  const cleaned = ('' + phoneNumber).replace(/\D/g, '');
  const match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);
  if (match) {
    const formattedNumber = `(${match[1]}) ${match[2]} ${match[3]}`;
    return (
      <a
        href={`tel:+1${phoneNumber}`}
        className="unstyled-link"
      >{`${formattedNumber} `}</a>
    );
  }
  return null;
}

const ContactSection = () => {
  const strapi = useStrapiContext();
  // const logo =
  //   strapi.strapiGlobal.logo.localFile.childImageSharp.gatsbyImageData;
  // const companyName = strapi.strapiGlobal.companyName;
  const supportEmail =
    strapi.strapiGlobal.supportEmail || 'support@overpassmarketing.com';
  const phone =
    formatPhoneNumber(strapi.strapiGlobal.mainPhone) || '(888) 888-8888';
  const address = strapi.strapiGlobal.address[0] || '';
  const businessHours = strapi.strapiGlobal.businessHours || '';

  const googleMapSrc = `https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d13391.867053855243!2d-97.0102869!3d32.9518869!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x864db41798f4d733%3A0xee12f65fee65de05!2sClarity%20Windows%C2%AE%20and%20Doors!5e0!3m2!1sen!2sus!4v1715967173931!5m2!1sen!2sus" width="600" height="450" style="border:0;" allowfullscreen="" loading="lazy" referrerPolicy="no-referrer-when-downgrade`;

  return (
    <div className="container flex mx-auto p-4 max-w-5xl">
      <div className="w-1/2">
        <h1 className="text-4xl font-bold mb-4">Contact Us</h1>

        <div className="md:ml-6 flex">
          <div className="flex flex-col text-center text-brandLight md:text-left">
            <div className="flex items-center text-sm uppercase mb-4">
              <FaMapMarkerAlt className="mr-4" />
              <div className="">
                {address.street}
                <br />
                {address.city}, {address.state} {address.zip}
              </div>
            </div>
            <div className="flex items-center text-sm uppercase mb-4">
              <FaPhoneAlt className="mr-4" />
              <a href={`tel:${phone}`} className="text-brandLight">
                {phone}
              </a>
            </div>
            <div className="flex items-center text-sm uppercase mb-4">
              <FaClock className="mr-4" />
              <p className="text-brandLight text-sm my-0">{businessHours}</p>
            </div>
            <div className="flex items-center text-sm uppercase mb-4">
              <FaEnvelope className="mr-4" />
              <a href={`mailto:${supportEmail}`} className="text-brandLight">
                {supportEmail}
              </a>
            </div>
            <div className="flex items-center text-sm uppercase mb-4">
              {/* <FaHome className="mr-4" /> */}
              <p
                href="mailto:support@overpassmarketing.com"
                className="text-brandLight text-sm my-0"
              >
                Showroom open to the
                <br /> public by appointment
              </p>
            </div>
          </div>
        </div>
      </div>
      <div className="w-1/2">
        <h2 className="text-2xl font-bold mb-4">Find Us</h2>
        <div className="w-full h-64">
          <iframe
            src={googleMapSrc}
            width="100%"
            height="100%"
            style={{ border: 0 }}
            allowFullScreen=""
            loading="lazy"
            title="Google Map"
          ></iframe>
        </div>
      </div>
    </div>
  );
};

const ContactPage = ({ location }) => {
  return (
    <Layout location={location}>
      <ContactSection />
    </Layout>
  );
};

export default ContactPage;

export const Head = ({ data, location }) => (
  <Seo
    title={`Contact Us`}
    description={`Contact Clarity Windows and Doors for all your window and door needs. Serving all of North Texas.`}
    pathname={`${location.pathname}`}
  />
);
